import React, { useState } from 'react';
import bestLogo from '../assets/Logos/BEST-Logo-kremasto.png';

function Footer() {
  const [copied, setCopied] = useState('');

  const handlePhoneClick = (e, number) => {
    const isTouch = typeof window !== 'undefined' && (('ontouchstart' in window) || navigator.maxTouchPoints > 0);
    if (!isTouch) {
      e.preventDefault();
      const write = navigator.clipboard && navigator.clipboard.writeText;
      if (write) {
        navigator.clipboard.writeText(number).then(() => {
          setCopied(number);
          setTimeout(() => setCopied(''), 2000);
        }).catch(() => {
          setCopied(number);
          setTimeout(() => setCopied(''), 2000);
        });
      } else {
        setCopied(number);
        setTimeout(() => setCopied(''), 2000);
      }
    }
  };
  return (
    <footer
      className="w-full py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden"
      style={{
        backgroundColor: '#749269',
        borderTop: '3px solid #E4570B',
        boxShadow: '0 -8px 40px rgba(0, 0, 0, 0.18)',
        borderTopLeftRadius: '14px',
        borderTopRightRadius: '14px',
        zIndex: 10
      }}
    >
      {/* Animated background pattern */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, #E4570B 0%, transparent 50%), radial-gradient(circle at 80% 80%, #EFA74F 0%, transparent 50%)',
          animation: 'pulse 8s ease-in-out infinite',
        }}
      />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          {/* Left Side - Logo & Organization Info */}
          <div className="lg:col-span-5 text-center lg:text-left">
            {/* BEST Logo - No background */}
            <div className="mb-8 flex justify-center lg:justify-start">
              <img
                src={bestLogo}
                alt="BEST Skopje Logo"
                className="h-32 w-auto sm:h-36 md:h-40 drop-shadow-2xl"
              />
            </div>

            <h3
              className="text-2xl sm:text-3xl mb-6 leading-tight"
              style={{
                color: '#DFC293',
                fontFamily: 'Sagewold, serif',
                textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
              }}
            >
              Борд на Европски Студенти по Технологија - Скопје
            </h3>

            <div
              className="text-lg sm:text-xl leading-relaxed mb-8"
              style={{
                color: '#DFC293',
                fontFamily: 'Sagewold, serif',
                opacity: 0.95,
              }}
            >
              <p>Барака 5, Факултет за Електроника</p>
              <p>и Информациски Технологии</p>
              <p>Руѓер Бошковиќ 66, Карпош 2</p>
              <p>1000 Скопје, Македонија</p>
            </div>

            {/* Social Links */}
            <div className="flex justify-center lg:justify-start gap-4 flex-wrap">
              {[
                { href: 'https://best.org.mk/', icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z', label: 'Website' },
                { href: 'mailto:skopje@best.org.mk', icon: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z', label: 'Email' },
                { href: 'https://www.facebook.com/bestskopje', icon: 'M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z', label: 'Facebook' },
                { href: 'https://www.instagram.com/bestskopje/', icon: 'M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z', label: 'Instagram' },
                { href: 'https://www.linkedin.com/company/best-skopje/', icon: 'M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z', label: 'LinkedIn' },
              ].map((social, idx) => (
                <a
                  key={idx}
                  href={social.href}
                  target={social.href && social.href.startsWith('http') ? '_blank' : undefined}
                  rel={social.href && social.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className="w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:rotate-6"
                  style={{
                    backgroundColor: '#E4570B',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255,255,255,0.2)',
                  }}
                  aria-label={social.label}
                  title={social.label}
                >
                  <svg className="w-7 h-7" fill="#DFC293" viewBox="0 0 24 24">
                    <path d={social.icon} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Right Side - Contact Section with creative layout */}
          <div className="lg:col-span-7">
            <h3
              className="text-3xl sm:text-4xl mb-8 text-center lg:text-left"
              style={{
                color: '#E4570B',
                fontFamily: 'Zeitmax, sans-serif',
                textShadow: '0 0 18px rgba(239, 167, 79, 0.28), 0 2px 10px rgba(0,0,0,0.3)',
                letterSpacing: '0.05em',
              }}
            >
              Contact Us
            </h3>

            <div className="space-y-6">
              {/* Contact 1 - Creative angled design */}
              <div
                className="relative p-8 group cursor-pointer transition-all duration-500 hover:translate-x-2"
                style={{
                  background: 'linear-gradient(135deg, rgba(228, 87, 11, 0.12) 0%, rgba(239, 167, 79, 0.08) 100%)',
                  border: '2px solid',
                  borderColor: '#E4570B',
                  borderRadius: '16px',
                  boxShadow: '0 8px 30px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255,255,255,0.1)',
                  clipPath: 'polygon(0 0, 100% 0, 100% 85%, 95% 100%, 0 100%)',
                }}
              >
                <div
                  className="absolute top-0 right-0 w-24 h-24 rounded-bl-full opacity-20"
                  style={{ backgroundColor: '#EFA74F' }}
                />
                <h4
                  className="text-2xl sm:text-3xl mb-2"
                  style={{
                    color: '#EFA74F',
                    fontFamily: 'Sagewold, serif',
                    textShadow: '0 2px 8px rgba(0,0,0,0.2)',
                  }}
                >
                  Анастасија Мицова
                </h4>
                <p
                  className="text-xl mb-4 italic"
                  style={{
                    color: '#DFC293',
                    fontFamily: 'Sagewold, serif',
                    opacity: 0.9,
                  }}
                >
                  Главен организатор
                </p>
                <div className="space-y-2">
                  <a
                    href="mailto:anastasija.micova@best-eu.org"
                    className="flex items-center gap-3 text-lg group/link"
                    style={{ color: '#DFC293', fontFamily: 'Sagewold, serif' }}
                  >
                    <span className="transition-transform group-hover/link:translate-x-1">📧</span>
                    <span className="group-hover/link:underline">anastasija.micova@best-eu.org</span>
                  </a>
                  <a
                    href={`tel:+38971962505`}
                    onClick={(e) => handlePhoneClick(e, '+38971962505')}
                    className="flex items-center gap-3 text-lg"
                    style={{ color: '#DFC293', fontFamily: 'Sagewold, serif' }}
                  >
                    <span>📱</span>
                    <span>+389 71 962 505</span>
                    {copied === '+38971962505' && (
                      <span className="ml-2 text-sm" style={{ color: '#EFA74F' }}>
                        Copied
                      </span>
                    )}
                  </a>
                </div>
              </div>

              {/* Contact 2 - Creative angled design (mirrored) */}
              <div
                className="relative p-8 group cursor-pointer transition-all duration-500 hover:translate-x-2"
                style={{
                  background: 'linear-gradient(135deg, rgba(239, 167, 79, 0.12) 0%, rgba(228, 87, 11, 0.18) 100%)',
                  border: '2px solid',
                  borderColor: '#E4570B',
                  borderRadius: '16px',
                  boxShadow: '0 8px 30px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255,255,255,0.1)',
                  clipPath: 'polygon(5% 0, 100% 0, 100% 100%, 0 100%, 0 15%)',
                }}
              >
                <div
                  className="absolute bottom-0 left-0 w-24 h-24 rounded-tr-full opacity-20"
                  style={{ backgroundColor: '#EFA74F' }}
                />
                <h4
                  className="text-2xl sm:text-3xl mb-2"
                  style={{
                    color: '#EFA74F',
                    fontFamily: 'Sagewold, serif',
                    textShadow: '0 2px 8px rgba(0,0,0,0.2)',
                  }}
                >
                  Марко Панев
                </h4>
                <p
                  className="text-xl mb-4 italic"
                  style={{
                    color: '#DFC293',
                    fontFamily: 'Sagewold, serif',
                    opacity: 0.9,
                  }}
                >
                  Одговорен за натпреварувачи
                </p>
                <div className="space-y-2">
                  <a
                    href="mailto:marko.panev@BEST-eu.org"
                    className="flex items-center gap-3 text-lg group/link"
                    style={{ color: '#DFC293', fontFamily: 'Sagewold, serif' }}
                  >
                    <span className="transition-transform group-hover/link:translate-x-1">📧</span>
                    <span className="group-hover/link:underline">marko.panev@BEST-eu.org</span>
                  </a>
                  <a
                    href={`tel:+38979297604`}
                    onClick={(e) => handlePhoneClick(e, '+38979297604')}
                    className="flex items-center gap-3 text-lg"
                    style={{ color: '#DFC293', fontFamily: 'Sagewold, serif' }}
                  >
                    <span>📱</span>
                    <span>+389 79 297 604</span>
                    {copied === '+38979297604' && (
                      <span className="ml-2 text-sm" style={{ color: '#EFA74F' }}>
                        Copied
                      </span>
                    )}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Divider */}
        <div
          className="h-1 w-full mb-8"
          style={{
            background: 'linear-gradient(90deg, transparent 0%, #E4570B 20%, #EFA74F 50%, #E4570B 80%, transparent 100%)',
            boxShadow: '0 0 20px rgba(0,0,0,0.12)',
          }}
        />

        {/* Copyright */}
        <div className="text-center">
          <p
            className="text-lg sm:text-xl"
            style={{
              color: '#DFC293',
              opacity: 0.95,
              fontFamily: 'Sagewold, serif',
              textShadow: '0 1px 3px rgba(0,0,0,0.3)',
            }}
          >
            © Designed by IT Team BEST Skopje 2025 - All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
